export default {"src":"/_next/static/media/play-button-overlay.67b4b5c0.svg","height":60,"width":60};